/**
 * @generated SignedSource<<8e9d9123ce279b4c28e88e7d5ff8d87f>>
 * @relayHash 68ec4d145458b136c5c6de705550c801
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2892a11d92b5792c27fed4e8804d91d890906f7a35d85fa5fc9f2ea8cde86055

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { mainpanel_viewSettingsPanelQuery } from './mainpanel_viewSettingsPanelQuery.graphql';

const node: PreloadableConcreteRequest<mainpanel_viewSettingsPanelQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "2892a11d92b5792c27fed4e8804d91d890906f7a35d85fa5fc9f2ea8cde86055",
    "metadata": {},
    "name": "mainpanel_viewSettingsPanelQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
